<p>
  {{'DOCOPEN.BODY' | translate }}
</p>
<div class="buttonContainer">
  <input type="submit" value="{{'COMMON.YES' | translate}}" class="cb-btn" (click)="ok()"/>
  <input type="submit" value="{{'COMMON.NO' | translate}}" class="cb-btn" (click)="no()"/>
</div>
